import React from 'react'
import { cardStyle, detailsBoxStyle, detailsTextStyle, detailsTextStyle2, detailsTextStyle3, imageBoxStyle, imageStyle, nameTextStyle } from './WORKercard_css'
import { Box, Typography } from '@mui/material'
import { amber, bgRed, green, headingBlue, maroon } from '../../../assets/colors'
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import { lightGreen } from '@mui/material/colors';

const WORKercard = (props) => {
    const data = props.data 
  return (
    <>
    <Box style={cardStyle}>
        <Box style={{width: '97%', display: 'flex', justifyContent: 'right', padding: '0.2rem', marginRight: '0.5rem'}}>
                <CardMembershipIcon style={{fontSize: '1rem', color:  data?.isMemCardGenerated ? '#558b2f' : maroon}}></CardMembershipIcon>
        </Box>
        <Box style={imageBoxStyle}>
            <img src={require('../../../assets/images/manager.png')} 
                style={imageStyle}
            ></img>
        </Box>
        <Box style={detailsBoxStyle}>
            <Typography style={nameTextStyle}>
                {`${data.name}`}
            </Typography>
            <Typography style={{...detailsTextStyle, color: headingBlue}}>
                {`${data.gender}  ${data.contactNumber}`}
            </Typography>
            <Typography style={{...detailsTextStyle, color: bgRed}}>
                {`${data.chapterCode} ${data.id}`}
            </Typography>
            <Typography style={{...detailsTextStyle, color: green}}>
                {`${data.district},  ${data.chapter}`}
            </Typography>
            {/* <Typography style={{...detailsTextStyle, color: green}}>
                {`${data.chapter}`}
            </Typography> */}
        </Box>
    </Box>
    </>
  )
}

export default WORKercard
